<template>
  <b-overlay :show="loading" rounded="sm">
    <b-card title="سئوی صفحه اصلی">
      <b-form-group label="عنوان متا" label-for="home-seo-title">
        <b-form-input id="home-seo-title" v-model.trim="seoTitle" maxlength="200" />
        <small>{{ seoTitle.length }}/200 کاراکتر</small>
      </b-form-group>
      <b-form-group label="توضیحات متا" label-for="home-seo-description">
        <b-form-textarea id="home-seo-description" v-model.trim="seoDescription" rows="4" maxlength="10000" />
        <small>{{ seoDescription.length }}/10000 کاراکتر</small>
      </b-form-group>
      <b-button variant="primary" :disabled="loading || !seoTitle.trim() || !seoDescription.trim()" @click="save">
        ذخیره
      </b-button>
    </b-card>
  </b-overlay>
</template>

<script>
import { BOverlay, BCard, BFormGroup, BFormInput, BFormTextarea, BButton } from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent'
import { StaticPageGetByTypeRequest, StaticPageCreateRequest, StaticPageUpdateRequest } from '@/libs/Api/StaticPage'

const HOME_SEO_TYPE = 1001

export default {
  name: 'HomeSeo',
  title: 'سئوی صفحه اصلی - پنل ادمین بنفشه باقری',
  components: { BOverlay, BCard, BFormGroup, BFormInput, BFormTextarea, BButton },
  data() {
    return { loading: false, staticPageId: null, seoTitle: '', seoDescription: '' }
  },
  created() { this.load() },
  methods: {
    async load() {
      this.loading = true
      try {
        const request = new StaticPageGetByTypeRequest(this)
        request.setType(HOME_SEO_TYPE)
        await request.fetch(items => {
          const page = Array.isArray(items) ? items[0] : null
          this.staticPageId = page?.staticPageId || null
          this.seoTitle = page?.title || ''
          this.seoDescription = page?.content || ''
        }, () => {})
      } finally {
        this.loading = false
      }
    },
    async save() {
      const title = this.seoTitle.trim()
      const content = this.seoDescription.trim()
      if (!title || !content) return
      this.loading = true
      try {
        const request = this.staticPageId
          ? new StaticPageUpdateRequest(this)
          : new StaticPageCreateRequest(this)
        request.setParams({ staticPageId: this.staticPageId, type: HOME_SEO_TYPE, state: 1, title, content })
        let saved = false
        await request.fetch(() => { saved = true }, () => {})
        if (saved) {
          this.$toast({
            component: ToastificationContent,
            position: 'bottom-center',
            props: { title: 'عملیات موفق', icon: 'CheckIcon', variant: 'success', text: 'متای صفحه اصلی ذخیره شد.' },
          })
          await this.load()
        }
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
